/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One row per metric with the metric name first, then one numeric column per item. Each item becomes a polygon connecting its values across the metric axes.`)
};

const es_radar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una fila por métrica con el nombre de la métrica primero, luego una columna numérica por elemento. Cada elemento se convierte en un polígono que conecta sus valores a través de los ejes de métricas.`)
};

const de_radar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Zeile pro Kennzahl, wobei der Kennzahlname zuerst steht, gefolgt von einer numerischen Spalte pro Element. Jedes Element wird zu einem Polygon, das seine Werte über die Kennzahlachsen verbindet.`)
};

const nl_radar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén rij per metric met eerst de metricnaam, dan één numerieke kolom per item. Elk item wordt een veelhoek die zijn waarden over de metricassen verbindt.`)
};

const fr_radar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une ligne par métrique avec le nom de la métrique en premier, puis une colonne numérique par élément. Chaque élément devient un polygone reliant ses valeurs à travers les axes de métriques.`)
};

const it_radar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una riga per metrica con il nome della metrica per primo, poi una colonna numerica per elemento. Ogni elemento diventa un poligono che collega i suoi valori attraverso gli assi delle metriche.`)
};

const pt_br2_radar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma linha por métrica com o nome da métrica primeiro, depois uma coluna numérica por item. Cada item se torna um polígono conectando seus valores nos eixos de métrica.`)
};

const pt_radar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma linha por métrica com o nome da métrica primeiro, seguido de uma coluna numérica por item. Cada item torna-se um polígono que liga os seus valores ao longo dos eixos das métricas.`)
};

const ja_radar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各行に1つの指標を、最初に指標名、続いて各項目に1つの数値列を入れます。各項目は指標軸にわたる値を結ぶ多角形になります。`)
};

const zh_radar_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每行一个指标，指标名称在前，之后每列为一个项目的数值。每个项目会成为一个连接其各指标轴数值的多边形。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_faq_a1", locale)
	if (locale === "en") return en_radar_faq_a1(inputs)
	if (locale === "es") return es_radar_faq_a1(inputs)
	if (locale === "de") return de_radar_faq_a1(inputs)
	if (locale === "nl") return nl_radar_faq_a1(inputs)
	if (locale === "fr") return fr_radar_faq_a1(inputs)
	if (locale === "it") return it_radar_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_radar_faq_a1(inputs)
	if (locale === "pt") return pt_radar_faq_a1(inputs)
	if (locale === "ja") return ja_radar_faq_a1(inputs)
	return zh_radar_faq_a1(inputs)
};